<template>
  <v-layout column>
    <loading-content
      :loading="loading"
      :error="error"
      :isTab="false">

      <v-form ref="form">
        <v-layout align-center justify-center ma-4>
          <input-image
            :readonly="readonly"
            :image="attributes.picture_path"
            @image="onImage"
          />
        </v-layout>

        <v-text-field
          outline
          v-model="attributes.document"
          :rules="has_document || readonly ? [] : [rules.required, rules.cpf]"
          :disabled="cpfTouched || has_document || readonly"
          :background-color="readonly ? '#ccc': ''"
          mask="###.###.###-##"
          label="CPF"/>

        <v-text-field
          outline
          v-model="attributes.name"
          :rules="readonly ? [] : [rules.required]"
          :disabled="blockDueCpfSearch || readonly"
          :background-color="blockDueCpfSearch || readonly ? '#ccc': ''"
          label="NOME COMPLETO/ FULL NAME"/>

        <v-text-field
          outline
          v-model="relation_type"
          :rules="readonly ? [] : [rules.required]"
          :disabled="blockDueCpfSearch || readonly"
          :background-color="blockDueCpfSearch || readonly ? '#ccc': ''"
          label="TIPO DE RELACIONAMENTO COM O ALUNO/ RELATIONSHIP TO THE STUDENT"/>

        <v-text-field
          outline
          v-model="attributes.mobile_phone"
          :rules="readonly ? [] : [rules.required]"
          :disabled="blockDueCpfSearch || readonly"
          :background-color="blockDueCpfSearch || readonly ? '#ccc': ''"
          label="TELEFONE CELULAR / MOBILE PHONE"/>
      </v-form>

    </loading-content>
  </v-layout>
</template>

<script>
import InputImage from '@/components/InputImage'
import * as cpfValidation from '@/helpers/cpfValidation'
import * as api from '@/api'
import { nestedRegistry, formTabs } from '@/mixins'
import LoadingContent from '@/components/LoadingContent'

/**
 * @group Form
 * Componente de form para autorizados a retirar o estudante
 */
export default {
  name: 'FormAuthorizedResponsible',

  components: {
    InputImage,
    LoadingContent
  },

  data: () => ({
    rules: {
      required: v => !!v || 'Campo obrigatório/Field is required',
      cpf: value => {
        return cpfValidation.validate(value || '') || 'CPF Inválido/CPF Invalid'
      }
    },
    cpfTouched: false,
    blockDueCpfSearch: true,
    has_document: false
  }),

  props: {
    responsible_students_attributes: {
      type: Object,
      default: () => ({})
    },

    responsible_id: {
      type: Number,
      default: null
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  mixins: [nestedRegistry, formTabs],

  mounted () {
    if (!this.readonly) {
      if (this.responsible_id) {
        api.responsible.student.edit(this.currentStudentId, this.responsible_id)
          .then(({ data }) => {
            this.handleResponse({ data })
            if (this.attributes.document) this.has_document = true
            this.blockDueCpfSearch = false
          })
          .catch(this.handleError)
          .finally(this.handleFinally)
      } else {
        api.responsible.student.getModel(this.currentStudentId)
          .then(this.handleResponse)
          .catch(this.handleError)
          .finally(this.handleFinally)
      }
    } else {
      this.readonlyLoad(this.responsible_students_attributes)
    }
  },

  computed: {
    document () {
      return this.attributes.document
    },

    attributes: {
      get () {
        return this.form.responsible_attributes || {}
      },

      set (attributes) {
        this.form.responsible_attributes = attributes
      }
    },

    relation_type: {
      get () {
        return this.form.relation_type
      },

      set (relationType) {
        this.form.relation_type = relationType
      }
    }
  },

  methods: {
    // @vuese Método para tratativa de imagem
    onImage (image) {
      this.attributes.picture_path = image
      this.attributes.picture = { data: image }
      this.$forceUpdate()
    },

    /**
     * @vuese
     * Método para envio de dados da form
     */
    save () {
      if (this.validateForm()) {
        this.$emit('responsible_students_attributes', this.form)
      }
    }
  },

  watch: {
    responsible_students_attributes: {
      handler (newValue) {
        this.form = newValue
      },
      deep: true
    },

    document (newValue) {
      if (newValue && cpfValidation.validate(newValue) && !this.readonly && !this.responsible_id) {
        api.responsible.getByDocument(newValue).then(({ data }) => {
          if (data) {
            this.attributes = data
            this.blockDueCpfSearch = false
            this.cpfTouched = true
          } else {
            this.blockDueCpfSearch = false
            this.cpfTouched = false
          }
        }).catch(error => {
          throw new Error(error)
        })
      }
    }
  }
}
</script>
